import {
  Checkbox,
  Label,
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@simplicity/ui";

export function TimelineControls({
  hasData,
  minMs,
  maxMs,
  clampedRangeDays,
  availableDays,
  splitByFunction,
  setSplitByFunction,
  setRangeDays,
}: {
  hasData: boolean;
  minMs: number;
  maxMs: number;
  clampedRangeDays: number;
  availableDays: number;
  splitByFunction: boolean;
  setSplitByFunction: (v: boolean) => void;
  setRangeDays: (v: number) => void;
}) {
  return (
    <div className="flex items-center gap-3">
      <Label className="mr-3 inline-flex items-center gap-1.5 whitespace-nowrap text-sm text-muted-foreground">
        <Checkbox
          checked={splitByFunction}
          onCheckedChange={(v) => setSplitByFunction(v === true)}
        />
        Split by function
      </Label>
      {hasData && (
        <div className="inline-flex items-center gap-2 text-sm text-muted-foreground">
          <span className="timeline-range-label">
            {new Date(minMs).toLocaleDateString("en-US", { month: "short", day: "numeric" })}
          </span>
          <span className="text-muted-foreground/60">→</span>
          <span className="timeline-range-label">
            {new Date(maxMs).toLocaleDateString("en-US", { month: "short", day: "numeric" })}
          </span>
        </div>
      )}
      <Label className="inline-flex items-center gap-1.5 whitespace-nowrap text-sm text-muted-foreground">
        Days:
        <Select value={String(clampedRangeDays)} onValueChange={(v) => setRangeDays(Number(v))}>
          <SelectTrigger className="h-auto w-auto px-1.5 py-1">
            <SelectValue />
          </SelectTrigger>
          <SelectContent>
            {Array.from({ length: availableDays }, (_, i) => i + 1).map((d) => (
              <SelectItem key={d} value={String(d)}>
                {d}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
      </Label>
    </div>
  );
}
